import { render, staticRenderFns } from "./FlagsDropdown.vue?vue&type=template&id=1e267b8a&"
import script from "./FlagsDropdown.vue?vue&type=script&lang=js&"
export * from "./FlagsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports